import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Input, Label, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import DmsDocumentLayout from '../ECN/DmsFormLayout';
import EcnTabs from './DmsTabs';
import EcnHeaderTab from './tabs/EcnHeaderTab';
import EcnProductInfoTab from './tabs/EcnProductInfoTab';
import EcnDetailsTab from './tabs/EcnDetailsTab';
import EcnAssociatedDocsTab from './tabs/EcnAssociatedDocsTab';
import EcnAttachmentsTab from './tabs/EcnAttachmentsTab';
import EcnPropertiesTab from './tabs/EcnPropertiesTab';
import api from "../../../api";
import { useNavigate, useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from "uuid";
import { documentTabs } from "../documentTypeConfig"
import { literatureTypeOptions } from "../documentTypeConfig"
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ShuklaImg from "../../../assets/images/shukla.png"
import SswhiteImg from "../../../assets/images/sswhite.png"
import SssImage from "../../../assets/images/sss.png"
import "../../../assets/styles/ecnModal.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
// Round DMS-UAT-1 (2026) — Issue 9: normalize stored ECN Will Change tokens
// (legacy "Use to Deplation" spelling etc.) so resumed drafts / edited docs
// keep their saved checks against the canonical shared option list.
import { normalizeWillChangeValues } from "../constants/ecnWillChangeOptions";

const CreateEcn = () => {

    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            ["link", "clean"],
        ],
    };

    const quillFormats = [
        "header", "bold", "italic", "underline", "strike",
        "list", "bullet", "indent", "align",
        "color", "background", "link",
    ];
    const { id, docType } = useParams();


    // ✅ docMeta.docNumber fallback to id from URL param

    const [submitLoading, setSubmitLoading] = useState(false);
    const currentDocType = (docType || "ecn").toLowerCase();
    const tabs = documentTabs[currentDocType.toUpperCase()];
    const isECN = currentDocType === "ecn";

    const userId = JSON.parse(sessionStorage.getItem("authUser"))?.uid;
    const loggedInUser = {
        empId: userId
    };
    const [logoType, setLogoType] = useState("");

    // Hotfix 18 — react-quill does NOT reliably re-render its editor body
    // when the `value` prop changes asynchronously (it reads `value` on
    // mount but ignores later async updates). On draft resume, loadDocument
    // sets the content into state AFTER the editors already mounted empty,
    // so Purpose/Scope/etc. appeared blank even though the data was loaded.
    // Bumping this version after load changes each editor's `key`, forcing
    // a clean remount that picks up the loaded value. (Native inputs like
    // Document Title don't need this — they always reflect state.)
    const [contentVersion, setContentVersion] = useState(0);

    const navigate = useNavigate();

    const [modal_backdrop, setmodal_backdrop] = useState(false);

    const tog_backdrop = () => setmodal_backdrop(!modal_backdrop);

    // ──────────────────────────────────────────────────────────────────
    // Round R7 (2026) — Default manager auto-seed (Q20).
    //
    // Legacy modern code carried `const DEFAULT_MANAGER_ID = "3038"` here,
    // which was used to auto-seed `managerId` and `approvers[0]` on every
    // new doc. That single literal was the last hardcoded empId in the
    // modern DMS frontend.
    //
    // New behavior:
    //   • Form initializes with managerId="" and approvers=[] (blank).
    //   • On mount, in CREATE mode (not edit mode) AND for the ECN doctype
    //     ONLY (per Q20 — other doctypes leave the author to choose
    //     manually), a fetch to GET /api/dms/default-manager?country=<X>
    //     resolves the country DMS Manager and seeds both fields.
    //   • Resolved country comes from the JWT session ("countryCode" key
    //     — the legacy alias the rest of the FE already uses).
    //   • If the resolver returns 404 (no manager in country), or any
    //     other error, the fields stay blank and the author selects
    //     manually — best-effort UX nicety, never blocks creation.
    //
    // The defaultManagerId state below is the resolved value; once set,
    // the form's managerId/approvers fields read from it. It is NOT a
    // global constant — it varies by user and is fetched per-mount.
    // ──────────────────────────────────────────────────────────────────
    const [defaultManagerId, setDefaultManagerId] = useState("");
    const [defaultManagerError, setDefaultManagerError] = useState(null);

    const [docMeta, setDocMeta] = useState({
        docNumber: null,
        revision: 0,
        status: "Draft",
        // Round DMS-UAT-4 — raw numeric status code from the server in edit
        // mode (null until loadDocument returns). Drives correction mode.
        statusCode: null
    });

    const [formData, setFormData] = useState({
        title: "",
        changeReason: "",
        affectedParts: "",
        riskAssessment: ""
    });

    const isEditMode = !!id

    // ──────────────────────────────────────────────────────────────────
    // Round DMS-UAT-4 (2026) — correction mode (UAT: "when you edit
    // through awaiting release you don't need to submit for approval —
    // just edit and save").
    //
    // A document opened for editing at any status OTHER than Draft (60),
    // Pending Approval (0) or Rejected (50) is an already-approved record
    // being corrected by Document Control. In that mode:
    //   • the footer shows a single "Save Changes" button;
    //   • Save Draft is hidden (PUT save-draft would demote the doc to
    //     Status 60 — never valid for an approved document; the backend
    //     also refuses it);
    //   • Submit For Approval is hidden (the backend PUT override path
    //     keeps the status, preserves the frozen approval record, sends
    //     no approval emails, and audit-logs the edit).
    // ──────────────────────────────────────────────────────────────────
    const MUTABLE_STATUSES = [0, 50, 60];
    const isCorrectionMode =
        isEditMode
        && docMeta.statusCode !== null
        && docMeta.statusCode !== undefined
        && !MUTABLE_STATUSES.includes(Number(docMeta.statusCode));

    // Round DMS-UAT-4 — which flavor of success the modal should describe.
    const [successMode, setSuccessMode] = useState("submit"); // "submit" | "correction"

    // Round DMS-UAT-4 — shared, human-readable API error extractor
    // (previously only saveDraft had this; submitForApproval showed
    // alert(JSON.stringify(...)) which UAT saw as unreadable).
    const extractApiError = (err) => {
        const data = err?.response?.data;
        if (typeof data === "string") return data;
        if (data && typeof data === "object") {
            if (data.error) return data.error;
            if (data.errors && typeof data.errors === "object") {
                return Object.entries(data.errors)
                    .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
                    .join("\n");
            }
            return data.title || data.detail || JSON.stringify(data);
        }
        return err?.message || "Unknown error";
    };
    console.log("Editing ECN:", id)
    useEffect(() => {
        if (isEditMode) {
            loadDocument();
        }
    }, [id]);

    // Round R7 (2026) — auto-seed first approver from country DMS Manager
    // (replaces the legacy `DEFAULT_MANAGER_ID = "3038"` hardcode).
    //
    // Q20 scope: ECN ONLY. SOP/WI/FCD/LIT leave the manager + approver
    // fields blank for manual selection.
    //
    // Fires once per mount in create mode. Edit mode skips entirely —
    // loadDocument() already populates these fields from the server data.
    useEffect(() => {
        if (isEditMode) return;          // edit mode loads from server
        if (currentDocType !== "ecn") return;  // Q20: ECN only

        let cancelled = false;
        const seedManager = async () => {
            try {
                // Pull country from the JWT session — same place useAuth reads it.
                let userCountry = "USA";
                try {
                    const auth = JSON.parse(sessionStorage.getItem("authUser") || "{}");
                    userCountry = auth.countryCode || auth.country || "USA";
                } catch { /* fall back to USA */ }

                const res = await api.get("/dms/default-manager", { params: { country: userCountry } });
                const empId = res?.data?.empId;
                if (cancelled || !empId) return;

                setDefaultManagerId(String(empId));
                setDefaultManagerError(null);
                setEcnForm(prev => ({
                    ...prev,
                    properties: {
                        ...prev.properties,
                        managerId: String(empId),
                        // Only seed approvers if the author hasn't already
                        // started picking them — protects against the rare
                        // race where the user adds an approver before this
                        // request returns.
                        approvers: (prev.properties.approvers && prev.properties.approvers.length > 0)
                            ? prev.properties.approvers
                            : [String(empId)],
                    },
                }));
            } catch (err) {
                if (cancelled) return;
                // 404 = no manager in country. Other errors = network/server.
                // In either case the form just stays blank — Q20's auto-seed
                // is a UX nicety, not a hard requirement.
                const msg = err?.response?.status === 404
                    ? `No default DMS Manager configured for your country. Please select an approver manually.`
                    : (err?.response?.data?.error || err?.message || "Could not resolve default manager.");
                setDefaultManagerError(msg);
                console.warn("[Round R7] default-manager lookup:", msg);
            }
        };
        seedManager();
        return () => { cancelled = true; };
    }, [isEditMode, currentDocType]);

    const [ecnForm, setEcnForm] = useState({
        docTitle: "",
        purpose: "",
        scope: "",
        responsibilities: "",
        definitions: "",

        procedure: "",
        // Hotfix 20 / Audit gap #5 — these doctype-procedure-equivalents were
        // previously created dynamically on first keystroke (state-spread merge),
        // which works but is fragile. Initialise them explicitly so anything that
        // reads `ecnForm.workInstruction`/`form`/`notes` (buildPayload, refs,
        // logging) before the user types sees "" instead of `undefined`.
        workInstruction: "",
        form: "",
        notes: "",

        // Hotfix 20 / Audit gap #1 — Revision Log fields (for re-revisions of
        // non-ECN docs). Mirrors legacy DMSNew.vb txtSectionChanged /
        // txtChangeMade / radioTrainingYes/No/Optional/NA. Empty defaults
        // for new docs; user fills them when re-revving an existing doc.
        // Backend writes a DmsRevLog row on submit using these values
        // (defaults to "Initial Release" if blank).
        sectionChanged: "",
        changeMade: "",
        trainingRequired: "",

        literatureType: "",
        header: {
            title: "",
            dateNeeded: "",
            customerApprovalRequired: false,
            customerNotificationRequired: false
        },
        productInfo: {
            partDescription: "",
            partNumber: "",
            drawingNumbers: "",
            customerPartNumber: "",
            currentRev: "",
            newRev: ""
        },
        details: {
            descriptionOfChange: "",
            reasonsForChange: "",
            ecnWillChange: [],
            instructions: "",
            otherChangeText: ""
        },
        associatedDocs: [],
        attachments: [],
        properties: {
            authorId: loggedInUser.empId,
            // Round R7 (2026) — blank by default. Auto-seed effect below
            // populates these for ECN doctype on mount; non-ECN doctypes
            // leave them blank for manual selection per Q20.
            managerId: "",
            approvers: [],
            notificationList: [],
            // Round DMS-UAT-6 — server-resolved names carried from /full
            // (empId → name); see loadDocument.
            knownNames: {}
        }
    });
    const loadDocument = async () => {

        try {

            const res = await api.get(`/dms/${id}/full`);
            const data = res.data;

            let details = {};

            if (currentDocType === "ecn") {
                details = data.ecnDetails?.[0] || {};
            }
            let extraFieldValue = "";


            setEcnForm(prev => ({
                ...prev,

                docTitle: data.header.docTitle,

                purpose: data.header.purpose || "",
                scope: data.header.scope || "",
                responsibilities: data.header.responsibilities || "",
                definitions: data.header.specialDefinitions || "",


                procedure: currentDocType === "sop" ? data.header.procedure || "" : "",
                workInstruction: currentDocType === "wi" ? data.header.procedure || "" : "",
                form: currentDocType === "fcd" ? data.header.procedure || "" : "",
                notes: currentDocType === "lit" ? data.header.procedure || "" : "",
                literatureType: currentDocType === "lit" ? data.header.litType || "" : "",
                header: {
                    title: details.ecrTitle || "",
                    // Hotfix 19 — the backend returns dateNeeded as a full
                    // ISO datetime (e.g. "2026-06-15T00:00:00"), but a
                    // native <input type="date"> only accepts "yyyy-MM-dd"
                    // and renders blank for anything else. Slice off the
                    // time portion so the saved date actually displays on
                    // resume. (The date was saving fine all along — it just
                    // couldn't render in the wrong format.)
                    dateNeeded: data.productInfo?.dateNeeded
                        ? String(data.productInfo.dateNeeded).split("T")[0]
                        : "",
                    customerApprovalRequired: details.customerApprovalRequired || false,
                    customerNotificationRequired: details.customerNotificationRequired || false
                },
                productInfo: {
                    partDescription: data.productInfo?.partDescription || "",
                    partNumber: data.productInfo?.partNumber || "",
                    drawingNumbers: data.productInfo?.drawingNumber || "",
                    customerPartNumber: data.productInfo?.customerPartNumber || "",
                    currentRev: data.productInfo?.currentRev || "",
                    newRev: data.productInfo?.newRev || ""
                },

                details: {

                    descriptionOfChange: details.descriptionOfChange || "",
                    reasonsForChange: details.reasonForChange || "",
                    // Round DMS-UAT-1 — Issue 9: normalize legacy tokens AND
                    // restore the "Other" free-text from its stored
                    // "Other:<text>" token so it survives resume/edit instead
                    // of silently duplicating on the next save.
                    ...(() => {
                        const tokens = normalizeWillChangeValues(details.ecrWillChange);
                        const otherToken = tokens.find((t) => t.startsWith("Other:"));
                        return {
                            ecnWillChange: tokens.filter((t) => !t.startsWith("Other:")),
                            otherChangeText: otherToken
                                ? otherToken.slice("Other:".length)
                                : "",
                        };
                    })(),
                    implementationDateInstructions:
                        details.implementationDateInstructions || ""
                },

                associatedDocs: (data.associatedDocs || []).map(d => ({
                    dmsid: d.dmsId || d.dmsidChild,
                    docId: d.docId,
                    docTitle: d.title,
                    rev: d.rev
                })),

                attachments: (data.attachments || []).map(a => ({
                    id: a.id || uuidv4(),
                    fileName: a.fileName,
                    fileTitle: a.attachmentTitle,
                    subjectToApproval: a.subjectToApproval,
                    downloadUrl: a.downloadUrl
                })),

                properties: {
                    // Round DMS-P2-8 (2026) — owner escalation on Q-A1: the
                    // FORM must show the logged-in editor as the author the
                    // moment an existing doc opens for editing (legacy
                    // DMSNew set cboAuthor to loginUser on entering edit;
                    // the backend already stamps it on save — P2-5). The
                    // stored author remains only as a fallback when the
                    // session uid is unavailable, and Document Control can
                    // still re-pick anyone before saving.
                    authorId: loggedInUser.empId || data.header.author,
                    managerId: data.header.manager,
                    approvers: data.approvals?.map(a => String(a.approver)) || [],        // ✅
                    notificationList: data.notifications?.map(n => String(n.empid)) || [], // ✅
                    // Round DMS-UAT-6 — name pass-through. /full already
                    // resolves every approver/notification name against
                    // EmpBasic (ALL companies and statuses). The Properties
                    // tab's own lookup uses /WhosInBuilding/userList, which
                    // filters EmpStatus='A' AND Company='SSW' — so
                    // terminated employees and Shukla-company staff showed
                    // as bare EmpIDs. Carry the server-resolved names along
                    // so the tab can fall back to them.
                    knownNames: {
                        ...(Object.fromEntries(
                            (data.approvals || [])
                                .filter(a => a.approverName)
                                .map(a => [String(a.approver), a.approverName])
                        )),
                        ...(Object.fromEntries(
                            (data.notifications || [])
                                .filter(n => n.empName)
                                .map(n => [String(n.empid), n.empName])
                        )),
                        ...(data.header.authorName
                            ? { [String(data.header.author)]: data.header.authorName }
                            : {}),
                        ...(data.header.managerName
                            ? { [String(data.header.manager)]: data.header.managerName }
                            : {}),
                    }
                }
            }));

            setDocMeta({
                docNumber: data.header.docID,
                revision: data.header.rev,
                // Round DMS-UAT-4 — show the human label (backend supplies
                // statusLabel since UAT-1) and keep the raw code for the
                // correction-mode decision below.
                status: data.header.statusLabel ?? data.header.status,
                statusCode: data.header.status
            });

            // Hotfix 17 — restore the Document Branding radio from the
            // persisted value (embedded in rawText server-side). Older
            // drafts without a stored logo come back as "sswhite".
            if (data.header.logoType) {
                setLogoType(data.header.logoType);
            }

            // Hotfix 18 — content is now in state; force the rich-text
            // editors to remount so they actually display the loaded
            // Purpose/Scope/Responsibilities/Definitions/procedure values.
            setContentVersion(v => v + 1);

        }
        catch (err) {
            console.error("Failed to load document", err);
        }

    };
    let procedureValue = "";

    if (currentDocType === "sop") procedureValue = ecnForm.procedure;
    if (currentDocType === "wi") procedureValue = ecnForm.workInstruction;
    if (currentDocType === "fcd") procedureValue = ecnForm.form;
    if (currentDocType === "lit") procedureValue = ecnForm.notes;


    const buildPayload = () => {

        const payload = {
            documentTitle: ecnForm.docTitle,

            authorId: Number(ecnForm.properties.authorId),
            managerId: Number(ecnForm.properties.managerId),

            approverIds: ecnForm.properties.approvers.map(Number),
            notificationIds: ecnForm.properties.notificationList.map(Number),

            associatedDocuments: ecnForm.associatedDocs,
            attachments: ecnForm.attachments,

            // These fields go into DmsMain
            purpose: ecnForm.purpose || "",
            scope: ecnForm.scope || "",
            responsibilities: ecnForm.responsibilities || "",
            specialDefinitions: ecnForm.definitions || "",


            procedure: procedureValue || "",
            litType: currentDocType === "lit" ? ecnForm.literatureType || "" : null,
            logoType: logoType,

            // Hotfix 20 / Audit gap #1 — Revision Log fields. Backend writes
            // a DmsRevLog row on submit using these (defaults to "Initial
            // Release" if blank). Required on re-revisions of an already-
            // released doc (server-side validation).
            sectionChanged: ecnForm.sectionChanged || "",
            changeMade: ecnForm.changeMade || "",
            trainingRequired: ecnForm.trainingRequired || ""

        };

        // Only ECN sends ECN payload
        if (currentDocType === "ecn") {

            // Round DMS-UAT-5 — the ECN Details tab now uses rich-text
            // editors; Quill represents an EMPTY field as "<p><br></p>".
            // Normalize that shell back to "" at payload time so untouched
            // fields don't persist markup (the artifact UAT-2's
            // ToPlainText had to scrub out of old ecrWillChange rows).
            const stripEmptyHtml = (html) => {
                const t = (html || "").trim();
                return /^<p>(\s|<br\s*\/?>)*<\/p>$/i.test(t) ? "" : (html || "");
            };

            payload.ecn = {
                ecrTitle: ecnForm.header.title,
                customerApprovalRequired: ecnForm.header.customerApprovalRequired,
                customerNotificationRequired: ecnForm.header.customerNotificationRequired,

                descriptionOfChange: stripEmptyHtml(ecnForm.details.descriptionOfChange),
                reasonForChange: stripEmptyHtml(ecnForm.details.reasonsForChange),

                ecrWillChange: (() => {
                    const changes = [...(ecnForm.details.ecnWillChange || [])];

                    if (changes.includes("Other") && ecnForm.details.otherChangeText) {
                        changes.push(`Other:${ecnForm.details.otherChangeText}`);
                    }

                    return changes.join(",");
                })(),

                implementationDateInstructions:
                    stripEmptyHtml(ecnForm.details.implementationDateInstructions),

                partDescription: ecnForm.productInfo.partDescription,
                partNumber: ecnForm.productInfo.partNumber,
                drawingNumber: ecnForm.productInfo.drawingNumbers,

                customerPartNumber: ecnForm.productInfo.customerPartNumber,
                currentRev: ecnForm.productInfo.currentRev,
                newRev: ecnForm.productInfo.newRev,

                // Hotfix 13 — coerce empty string to null. The backend
                // DTO declares DateNeeded as `DateTime?`; System.Text.Json
                // can deserialize null/missing/valid-date but throws on
                // "" (empty string). That throw turns into the ASP.NET
                // problem-details 400 the user saw as "[object Object]".
                dateNeeded: ecnForm.header.dateNeeded || null
            };

        }

        return payload;
    };



    const submitForApproval = async () => {
        try {
            setSubmitLoading(true);

            const payload = buildPayload();
            console.log("Final Payload : ", JSON.stringify(payload, null, 2));

            if (isEditMode) {
                await api.put(`dms/${id}`, payload);
            } else {
                const res = await api.post(`dms/create/${currentDocType}`, payload);

                setDocMeta({
                    docNumber: res.data.docId,
                    revision: res.data.rev,
                    status: "Submitted"
                });
            }

            setSuccessMode("submit");
            setmodal_backdrop(true);
        } catch (err) {
            console.error("API Error:", err.response?.data);
            // Round DMS-UAT-4 — readable error instead of raw JSON dump.
            window.alert(`Failed to submit:\n${extractApiError(err)}`);
        } finally {
            setSubmitLoading(false);
        }
    };

    // ──────────────────────────────────────────────────────────────────
    // Round DMS-UAT-4 — Document Control correction save. Same PUT the
    // submit path uses; the backend recognizes the non-mutable status and
    // runs the override branch (status unchanged, approvals frozen, no
    // approval emails, audited). If no Change Made text was entered, a
    // default is recorded so the revision log always says something.
    // ──────────────────────────────────────────────────────────────────
    // Round DMS-5 (owner: the legacy ribbon trio must exist in EVERY edit,
    // including Document Control corrections of approved/released docs).
    // "Save & Close" — the existing in-place correction save, then leave.
    const saveCorrectionAndClose = async () => {
        // Round DMS-5 audit fix: saveCorrection swallows its own errors
        // (alert + stay), so gate the navigation on its success signal —
        // otherwise a FAILED save would still close the editor and the
        // user's changes would be silently lost.
        const ok = await saveCorrection();
        if (ok) navigate("/document-management");
    };

    // "Save & Send For Approval" on an approved/released doc — legacy
    // (DMSNew.vb:2954 Insert branch) created a NEW working row already
    // routed for approval. Modern sequence: start-revision (draft clone,
    // caller becomes its author) → PUT the clone with the CURRENT form
    // contents (which now also promotes it to Pending Approval, replaces
    // the approver rows and emails the approvers). The approved/released
    // original stays in force until the new revision is released.
    const sendCorrectionForApproval = async () => {
        if (!window.confirm(
            "Send these changes for approval as a NEW revision?\n\n" +
            "A fresh revision is created with YOU as its author (legacy rule) and routed to the approvers on the Properties tab. " +
            "The current approved/released revision stays in force until the new one is approved and released."))
            return;
        try {
            setSubmitLoading(true);
            const rev = await api.post(`dms/${id}/start-revision`);
            const newId = rev?.data?.newDmsId;
            if (!newId) throw new Error("start-revision returned no id");
            const payload = buildPayload();
            // Round DMS-7 — the clone was created with the EDITOR as its
            // author (legacy rule). The form payload still carries the
            // ORIGINAL author loaded from the released doc, and a Document
            // Control caller would trigger the audited author-change branch
            // and flip it straight back. Align the payload with the new
            // authorship so the PUT is a no-op on that column.
            payload.authorId = Number(loggedInUser?.empId) || payload.authorId;
            await api.put(`dms/${newId}`, payload);
            window.alert("New revision created and sent for approval.");
            navigate("/document-management");
        } catch (err) {
            console.error("Send-for-approval (new revision) failed:", err?.response?.data || err);
            window.alert(err?.response?.data?.error || "Failed to create/route the new revision.");
        } finally {
            setSubmitLoading(false);
        }
    };

    const saveCorrection = async () => {
        try {
            setSubmitLoading(true);
            const payload = buildPayload();
            if (!payload.changeMade) payload.changeMade = "Document Control correction";
            if (!payload.sectionChanged) payload.sectionChanged = "";
            await api.put(`dms/${id}`, payload);
            setSuccessMode("correction");
            setmodal_backdrop(true);
            return true; // Round DMS-5 audit fix: signal success to wrappers
        } catch (err) {
            console.error("Correction save failed:", err?.response?.data || err);
            window.alert(`Failed to save changes:\n${extractApiError(err)}`);
            return false;
        } finally {
            setSubmitLoading(false);
        }
    };
    const updateSection = (section, field, value) => {
        setEcnForm(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };
    // Round DMS-2 (owner request #7) — legacy DMSNew ribbon parity.
    // "Close Without Saving": confirm, discard, back to the DMS list.
    const closeWithoutSaving = () => {
        if (window.confirm("Close without saving? Any unsaved changes will be lost.")) {
            navigate("/document-management");
        }
    };

    // navigateAfter=false → the modern "Save Draft" (save and KEEP editing);
    // navigateAfter=true  → the legacy "Save & Close" (save, then leave).
    const saveDraft = async (navigateAfter = false) => {
        // Round DMS-UAT-4 — defensive: an approved document must never be
        // demoted to a draft. The button is hidden in correction mode; this
        // guard covers any other invocation path. (The backend refuses too.)
        if (isCorrectionMode) {
            window.alert("This document is past the draft stage. Use Save Changes instead.");
            return;
        }
        // Round R12 (2026) — real Save Draft.
        //
        // Pre-R12 this function just navigated away ("save" was a stub
        // that lost any work). The Phase 2.1 backend endpoints have been
        // sitting unused — wire them up now:
        //
        //   POST /api/dms/ecn/save-draft            → new draft
        //   PUT  /api/dms/ecn/save-draft/{dmsId}    → update existing
        //
        // Drafts use Status=60 (Q11's modern-only Draft state). On
        // success, `docMeta.docNumber` gets a "DRAFT-NNNNNN" placeholder
        // and the user can keep editing OR navigate to /dms/my-drafts
        // to find this doc again later.
        try {
            setSubmitLoading(true);

            const payload = buildPayload();
            console.log("Draft Payload :", JSON.stringify(payload, null, 2));

            let res;
            if (isEditMode || docMeta.docNumber?.toString().startsWith("DRAFT-")) {
                // Updating an existing draft (or any in-edit doc — backend
                // accepts the same shape and updates by dmsId).
                const targetId = id || docMeta.docNumber;
                // Hotfix 15 — use the real doctype, not hardcoded "ecn".
                // Saving a LIT/SOP/WI/FCD draft was storing it as ECN
                // because this URL was locked to /ecn/save-draft.
                res = await api.put(`dms/${currentDocType}/save-draft/${targetId}`, payload);
            } else {
                // New draft.
                res = await api.post(`dms/${currentDocType}/save-draft`, payload);
            }

            // Update local state so the user sees the draft was saved
            // and can continue editing without re-creating.
            if (res?.data) {
                setDocMeta({
                    docNumber: res.data.docId || res.data.dmsId || docMeta.docNumber,
                    revision: res.data.rev ?? docMeta.revision,
                    status: "Draft"
                });
            }

            // Notify + offer next-step. Toast import is at top of file
            // from react-toastify (used by R8's tasks tab already).
            if (navigateAfter) {
                // Legacy "Save & Close" — save, confirm, leave.
                window.alert("Draft saved. You can find it under My Drafts in the menu.");
                navigate("/dms/my-drafts");
            } else {
                // Modern "Save Draft" — save and keep editing in place.
                window.alert("Draft saved. You can keep editing — it is also under My Drafts.");
            }
        } catch (err) {
            console.error("Save draft failed:", err?.response?.data || err);
            // Hotfix 13 — show a usable error message.
            // Pre-hotfix: `${err?.response?.data}` on an object body
            // (ASP.NET problem-details JSON) stringified as "[object
            // Object]" — opaque, unhelpful. Now we detect strings vs
            // objects and pull out the meaningful field.
            const data = err?.response?.data;
            let msg;
            if (typeof data === "string") {
                msg = data;
            } else if (data && typeof data === "object") {
                // ASP.NET problem-details typically has { title, status,
                // errors }. Prefer `errors` map (validation), fall back
                // to `title`, fall back to full JSON.
                if (data.errors && typeof data.errors === "object") {
                    msg = Object.entries(data.errors)
                        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
                        .join("\n");
                } else {
                    msg = data.title || data.detail || JSON.stringify(data);
                }
            } else {
                msg = err?.message || "unknown error";
            }
            window.alert(`Failed to save draft:\n${msg}`);
        } finally {
            setSubmitLoading(false);
        }
    };
    const breadcrumbTitle = isEditMode
        ? `Edit ${currentDocType.toUpperCase()} - #${docMeta.docNumber || id}`
        : `Create New ${currentDocType.toUpperCase()}`;
    return (


        <DmsDocumentLayout

            title={breadcrumbTitle}
            docNumber={docMeta.docNumber}
            revision={docMeta.revision}

            docType={currentDocType}
            docTitle={ecnForm.docTitle}
            onDocTitleChange={(value) =>
                setEcnForm(prev => ({
                    ...prev,
                    docTitle: value
                }))
            }
            status={docMeta.status}
            statusCode={docMeta.statusCode}
            onSaveDraft={() => saveDraft(false)}
            onSubmit={submitForApproval}
            // Round DMS-2 (owner request #7) — legacy ribbon trio.
            onCloseWithoutSaving={closeWithoutSaving}
            onSaveAndClose={() => saveDraft(true)}
            // Round DMS-UAT-4 — correction mode for editing approved docs
            // through Awaiting Release (single Save Changes button).
            correctionMode={isCorrectionMode}
            onSaveCorrection={saveCorrection}
            // Round DMS-5 — legacy trio in correction mode too.
            onSaveCorrectionAndClose={saveCorrectionAndClose}
            onSendCorrectionForApproval={sendCorrectionForApproval}
            // ──────────────────────────────────────────────────────────────
            // Hotfix (post-R10, 2026) — pre-existing modern bug, not from
            // any round. The old check was:
            //
            //   disabled={!docMeta.docNumber || submitLoading}
            //
            // `docMeta.docNumber` is null on a fresh new doc (it only gets
            // populated after a successful submitForApproval POST returns
            // the auto-generated docId). So:
            //
            //   button disabled → can't click → can't POST → docNumber
            //   never set → button stays disabled forever.
            //
            // Edit mode worked because loadDocument() pre-populates docNumber
            // from the URL param; create-new mode was broken on every doctype.
            //
            // `submitLoading` alone is sufficient to prevent double-submit.
            // ──────────────────────────────────────────────────────────────
            disabled={submitLoading}

        >

            <Card className="shadow-sm border-0 mb-3">
                <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                    <h6 className="card-title fw-semibold mb-1">
                        <i className="ri-image-line align-bottom me-1 text-muted" />
                        Document Branding
                    </h6>
                    <p className="text-muted small mb-0">Select the logo to use on the rendered PDF</p>
                </CardHeader>
                <CardBody>
                    <div className="d-flex gap-3 align-items-center flex-wrap">
                        <label className={`logo-option ${logoType === "sswhite" ? "selected" : ""}`}>
                            <input type="radio" name="logoType" value="sswhite"
                                checked={logoType === "sswhite"}
                                onChange={(e) => setLogoType(e.target.value)} />
                            <img src={SswhiteImg} alt="SS White" className="logo-img" />
                            <div className="logo-title">SS White</div>
                        </label>

                        <label className={`logo-option ${logoType === "shukla" ? "selected" : ""}`}>
                            <input type="radio" name="logoType" value="shukla"
                                checked={logoType === "shukla"}
                                onChange={(e) => setLogoType(e.target.value)} />
                            <img src={ShuklaImg} alt="Shukla Medical" className="logo-img" />
                            <div className="logo-title">Shukla Medical</div>
                        </label>
                        <label className={`logo-option ${logoType === "sss" ? "selected" : ""}`}>
                            <input type="radio" name="logoType" value="sss"
                                checked={logoType === "sss"}
                                onChange={(e) => setLogoType(e.target.value)} />
                            <img src={SssImage} alt="SSS" className="logo-img" />
                            <div className="logo-title">Shukla Surgical Support</div>
                        </label>
                    </div>

                    {currentDocType === "lit" && (
                        <div className="mt-4">
                            <Label className="fw-semibold mb-1" style={{ fontSize: 13 }}>
                                Literature Type
                            </Label>
                            <Input
                                type="select"
                                value={ecnForm.literatureType || ""}
                                onChange={(e) =>
                                    setEcnForm(prev => ({
                                        ...prev,
                                        literatureType: e.target.value
                                    }))
                                }
                            >
                                <option value="">Select Literature Type</option>
                                {literatureTypeOptions.map((item) => (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    )}
                </CardBody>
            </Card>

            <EcnTabs tabs={tabs}>
                {(activeTab) => (
                    <>
                        {/* ---------- ECN specific tabs ---------- */}

                        {isECN && activeTab === "header" && (
                            <EcnHeaderTab
                                data={ecnForm.header}
                                update={(field, value) => updateSection("header", field, value)}
                            />
                        )}

                        {isECN && activeTab === "product" && (
                            <EcnProductInfoTab
                                data={ecnForm.productInfo}
                                update={(field, value) => updateSection("productInfo", field, value)}
                            />
                        )}

                        {isECN && activeTab === "details" && (
                            <EcnDetailsTab
                                // Round DMS-UAT-5 — the tab's rich-text editors
                                // (Description / Reasons / Instructions) need a
                                // remount after async load, same as the Hotfix 18
                                // quill-key pattern used for Purpose/Scope below.
                                key={`details-${contentVersion}`}
                                data={ecnForm.details}
                                update={(field, value) => updateSection("details", field, value)}
                            />
                        )}

                        {/* ---------- COMMON TABS ---------- */}

                        {activeTab === "associated" && (
                            <EcnAssociatedDocsTab
                                data={ecnForm.associatedDocs}
                                setData={(docs) =>
                                    setEcnForm(prev => ({
                                        ...prev,
                                        associatedDocs: docs
                                    }))
                                }
                            />
                        )}

                        {activeTab === "attachments" && (
                            <EcnAttachmentsTab
                                data={ecnForm.attachments}
                                setData={(files) =>
                                    setEcnForm(prev => ({
                                        ...prev,
                                        attachments: files
                                    }))
                                }
                            />
                        )}

                        {activeTab === "properties" && (
                            <EcnPropertiesTab
                                data={ecnForm.properties}
                                update={(field, value) => updateSection("properties", field, value)}
                                defaultManagerId={defaultManagerId}
                            />
                        )}

                        {/* ---------- REVISION LOG TAB (SOP / WI / FCD / LIT) ---------- */}
                        {/* Hotfix 20 / Audit gap #1 — restored the legacy DMSNew form's
                            Revision Log group box. For initial releases, leave blank —
                            backend defaults ChangeMade to "Initial Release". For re-
                            revisions (rev>0 on an already-released doc), backend
                            validation requires SectionChanged + ChangeMade (≥10 chars)
                            + TrainingRequired selection. */}
                        {!isECN && activeTab === "revlog" && (
                            <div className="p-3">
                                <div className="alert alert-info py-2 mb-3" style={{ fontSize: "13px" }}>
                                    <i className="ri-information-line me-1"></i>
                                    Fill these fields when re-revising an already-released
                                    document. For a brand-new document, leave blank —
                                    they'll default to <em>Initial Release</em>.
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="revlog-section" className="form-label fw-semibold">
                                        Section / Paragraph Changed
                                    </label>
                                    <input
                                        id="revlog-section"
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. Section 4.2, Step 3"
                                        value={ecnForm.sectionChanged || ""}
                                        onChange={(e) =>
                                            setEcnForm(prev => ({ ...prev, sectionChanged: e.target.value }))
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="revlog-changemade" className="form-label fw-semibold">
                                        Description of Change Made
                                        <small className="text-muted ms-2">(minimum 10 characters on re-revisions)</small>
                                    </label>
                                    <textarea
                                        id="revlog-changemade"
                                        className="form-control"
                                        rows={4}
                                        placeholder="Describe what changed in this revision and why."
                                        value={ecnForm.changeMade || ""}
                                        onChange={(e) =>
                                            setEcnForm(prev => ({ ...prev, changeMade: e.target.value }))
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold d-block">Training Required?</label>
                                    {["Yes", "No", "Optional", "NA"].map(opt => (
                                        <div key={opt} className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="revlog-training"
                                                id={`revlog-training-${opt}`}
                                                value={opt}
                                                checked={ecnForm.trainingRequired === opt}
                                                onChange={(e) =>
                                                    setEcnForm(prev => ({ ...prev, trainingRequired: e.target.value }))
                                                }
                                            />
                                            <label className="form-check-label" htmlFor={`revlog-training-${opt}`}>
                                                {opt === "NA" ? "N/A" : opt}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* ---------- SIMPLE TEXT TABS (SOP / WI / FCD / LIT) ---------- */}

                        {!isECN &&
                            ["purpose", "scope", "responsibilities", "definitions", "procedure", "workInstruction", "notes", "form"]
                                .includes(activeTab) && (
                                <div style={{ minHeight: 300 }}>
                                    <ReactQuill
                                        key={`quill-${activeTab}-${contentVersion}`}
                                        theme="snow"
                                        value={ecnForm[activeTab] || ""}
                                        onChange={(content) =>
                                            setEcnForm(prev => ({
                                                ...prev,
                                                [activeTab]: content
                                            }))
                                        }
                                        modules={quillModules}
                                        formats={quillFormats}
                                        style={{ height: 280, marginBottom: 42 }}
                                    />
                                </div>
                            )
                        }

                    </>
                )}
            </EcnTabs>

            {/* Round DMS-UAT-4 — correction mode: capture what changed so the
                Revision History entry is meaningful (matches the Issue 14
                columns: Sec/Par. Changed + Change Made). Optional — if left
                blank, "Document Control correction" is recorded. */}
            {isCorrectionMode && (
                <Card className="shadow-sm border-0 mt-3">
                    <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                        <h6 className="card-title fw-semibold mb-1">
                            <i className="ri-history-line align-bottom me-1 text-muted" />
                            Correction Details (for Revision History)
                        </h6>
                        <p className="text-muted small mb-0">
                            Describe the correction — this appears under Sec/Par. Changed and
                            Change Made in the Revisions tab and the printed PDF.
                        </p>
                    </CardHeader>
                    <CardBody>
                        <Row className="g-3">
                            <Col md={4}>
                                <Label className="fw-semibold small mb-1">Sec/Par. Changed</Label>
                                <Input
                                    value={ecnForm.sectionChanged || ""}
                                    onChange={(e) => setEcnForm(prev => ({ ...prev, sectionChanged: e.target.value }))}
                                    placeholder="e.g. Product Info, Section 4.2"
                                />
                            </Col>
                            <Col md={8}>
                                <Label className="fw-semibold small mb-1">Change Made</Label>
                                <Input
                                    value={ecnForm.changeMade || ""}
                                    onChange={(e) => setEcnForm(prev => ({ ...prev, changeMade: e.target.value }))}
                                    placeholder="What was corrected? (defaults to 'Document Control correction')"
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            )}


            <Modal
                isOpen={modal_backdrop}
                toggle={tog_backdrop}
                backdrop="static"
                id="staticBackdrop"
                centered
            >
                <ModalHeader>
                    <h5 className="modal-title" id="staticBackdropLabel">Success</h5>
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <lord-icon
                        src="https://cdn.lordicon.com/lupuorrc.json"
                        trigger="loop"
                        colors="primary:#121331,secondary:#08a88a"
                        style={{ width: "120px", height: "120px" }}>
                    </lord-icon>

                    <div className="mt-4">
                        {successMode === "correction" ? (
                            <>
                                {/* Round DMS-UAT-4 — correction save confirmation */}
                                <h4 className="mb-3">Changes Saved</h4>
                                <p className="text-muted mb-2">
                                    The correction was saved. The document keeps its current
                                    status and the edit was recorded in Revision History.
                                </p>
                                <p className="text-muted small mb-4">
                                    <i className="ri-shield-check-line me-1"></i>
                                    No re-approval was triggered and no approval emails were sent.
                                </p>
                                <div className="hstack gap-2 ">
                                    <Button color="light" onClick={() => navigate("/dms/awaiting-release")}>Back to Awaiting Release</Button>
                                    <Button color="light" onClick={() => navigate("/document-management", { state: { refresh: true } })}>All Documents</Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <h4 className="mb-3">Document Submitted!</h4>
                                <p className="text-muted mb-2">
                                    Your document was saved and submitted for approval.
                                </p>
                                <p className="text-muted small mb-4">
                                    <i className="ri-mail-send-line me-1"></i>
                                    Approvers will receive notification emails in the next few seconds.
                                </p>
                                <div className="hstack gap-2 ">
                                    <Button color="light" onClick={() => navigate("/document-management", { state: { refresh: true } })} >Close</Button>
                                </div>
                            </>
                        )}
                    </div>
                </ModalBody>
            </Modal>
            {submitLoading && (
                <div className="submit-loading-overlay">
                    <div className="submit-loading-box">
                        <div className="spinner-border text-primary submit-loading-spinner" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="mt-3 fw-semibold">
                            {isCorrectionMode ? "Saving changes..." : "Submitting document..."}
                        </div>
                    </div>
                </div>
            )}
        </DmsDocumentLayout>

    );
};

export default CreateEcn;

